export default "__VITE_ASSET__BD7LDnuI__"